import { arrayOf, shape, string } from 'prop-types';

export const footnoteDataType = shape({
  meta: arrayOf(
    shape({
      data: string.isRequired
    })
  ).isRequired,
  name: string
});

export const customFootnoteType = shape({
  footnotes: arrayOf(
    shape({
      data: string.isRequired,
      name: string.isRequired
    })
  ),
  name: string
});

export type customFootnoteTypeTypescript = {
  footnotes: {
    date: string;
    name: string;
  }[];
};
